import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { ControlledMultiSelectorAssetInput } from '@/ui/organisms/multi-selector/ControlledMultiSelectorAssetInput'
import { Control } from 'react-hook-form'
import { TokenWithBalance } from '@/domain/common/types'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { SwapFormSchema } from '../../../logic/validators'
import { SearchableAssetSelector } from '@/ui/molecules/searchable-asset-selector/SearchableAssetSelector'

interface BuyProps {
  control: Control<SwapFormSchema>
  assets: TokenWithBalance[]
  selectedAsset: TokenWithBalance
  changeToken: (newSymbol: TokenSymbol) => void
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  maxSelectedFieldName?: string
  disabled?: boolean
  featuredAssets?: TokenSymbol[]
}

export function Buy(props: BuyProps) {
  const { control, assets, selectedAsset, maxSelectedFieldName, disabled, changeToken, onChange, featuredAssets } =
    props

  return (
    <Panel.Wrapper className="mt-2 p-4 pb-5">
      <Typography variant="h4" className="py-3 font-semibold">
        To
      </Typography>

      <div>
        <div className="mt-2 flex flex-row items-start gap-2">
          <ControlledMultiSelectorAssetInput
            fieldName="to.value"
            control={control}
            disabled
            token={selectedAsset.token}
            customOnChange={onChange}
            maxSelectedFieldName={maxSelectedFieldName}
            readOnly
          />

          <SearchableAssetSelector
            assets={assets}
            selectedAsset={selectedAsset.token}
            setSelectedAsset={changeToken}
            disabled={disabled}
            featuredAssets={
              typeof featuredAssets === 'undefined'
                ? ['HYPE', 'USDXL', 'USD₮0', 'UBTC', 'PURR', 'USDe', 'feUSD', 'stHYPE']
                : featuredAssets
            }
          />
        </div>
      </div>
    </Panel.Wrapper>
  )
}
